module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      blueBg: _vm.$route.meta.isBlueBg,
      transHeader: _vm.hasTransHeader,
      isAuthView: _vm.$route.meta.isAuthView,
      isLoggedOut: !_vm.$route.meta.isAuthView && !_vm.$store.state.user.scope
    },
    attrs: {
      "id": "app"
    }
  }, [_c('boot-loader', {
    attrs: {
      "loadingMessage": _vm.loadingMessage
    }
  }), _vm._v(" "), (_vm.loggedIn && !_vm.docked && _vm.isOpen) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$route.meta.isAuthView),
      expression: "!$route.meta.isAuthView"
    }],
    staticClass: "app-drawer-overlay",
    on: {
      "click": function($event) {
        return _vm.toggle(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$route.meta.isAuthView),
      expression: "!$route.meta.isAuthView"
    }],
    staticClass: "app-drawer",
    class: {
      open: _vm.isOpen,
      docked: _vm.docked,
      isMobile: !_vm.docked
    }
  }, [_c('div', {
    staticClass: "nav-head"
  }, [_c('div', {
    staticClass: "avatar",
    on: {
      "click": _vm.goToProfile
    }
  }, [(_vm.$store.state.user.scope.profile_thumb !== null) ? _c('img', {
    attrs: {
      "src": _vm.$store.state.user.scope.profile_thumb,
      "alt": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.upperTwoInitials))])]), _vm._v(" "), _c('div', {
    staticClass: "name",
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.display_name && _vm.$store.state.user.scope.use_display_name ? _vm.$store.state.user.scope.display_name : _vm.$store.state.user.scope.firstname)
    }
  }), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('div', {
    ref: "settingsMenu",
    staticClass: "settings-menu"
  }, [_c('button', {
    ref: "settingsTrigger",
    staticClass: "settings-trigger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSettingsMenu
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("settings")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuOpen),
      expression: "menuOpen"
    }],
    ref: "settingsDropdown",
    staticClass: "settings-dropdown"
  }, [_c('div', {
    staticClass: "menu-user",
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goToProfile()
      }
    }
  }, [_c('div', {
    staticClass: "avatar avatar--lg"
  }, [(_vm.$store.state.user.scope.profile_large) ? _c('img', {
    attrs: {
      "src": _vm.$store.state.user.scope.profile_large,
      "alt": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.upperTwoInitials))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-user-info"
  }, [_c('div', {
    staticClass: "menu-user-name",
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.display_name && _vm.$store.state.user.scope.use_display_name ? _vm.$store.state.user.scope.display_name : (_vm.$store.state.user.scope.firstname + ' ' + _vm.$store.state.user.scope.surname))
    }
  }), _vm._v(" "), (_vm.$store.state.user.scope.diabetes_type && _vm.$store.state.user.scope.diabetes_type.diabetes_type) ? _c('div', {
    staticClass: "menu-user-type",
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.diabetes_type.diabetes_type)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('hr', {
    staticClass: "menu-divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/dashboard')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dashboard")]), _vm._v(_vm._s(_vm.$t('message.dashboardAppBarText')) + "\n            ")]), _vm._v(" "), (!_vm.isHcpView) ? _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/questions?type=MY_QUESTIONS')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chat")]), _vm._v(_vm._s(_vm.$t('message.discussionTabMyQuestions')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/profile/' + _vm.$store.state.user.profile.profile_url)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v(_vm._s(_vm.$t('message.labelMyProfile')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/settings')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("settings")]), _vm._v(_vm._s(_vm.$t('message.settingsMenuTitleText')) + "\n            ")]), _vm._v(" "), (!_vm.isHcpView) ? _c('hr', {
    staticClass: "menu-divider"
  }) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/add-progress')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(_vm._s(_vm.$t('message.addProgressAppBarText')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/food-diary/')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(_vm._s(_vm.$t('message.foodDiaryAddFoodAppBarText')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('hr', {
    staticClass: "menu-divider"
  }) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('button', {
    staticClass: "menu-item",
    class: {
      disabled: _vm.showTestimonial
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goTo('/testimonials')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")]), _vm._v(_vm._s(_vm.$t('message.addTestimonialText')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.goToContact()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")]), _vm._v(_vm._s(_vm.$t('message.labelHelp')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAppMenu();
        _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("exit_to_app")]), _vm._v(_vm._s(_vm.$t('message.logOutText')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/dashboard"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v(_vm._s(_vm.isHcpView && _vm.isHcpUser ? 'home' : 'dashboard'))]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.dashboardMenuTitleText')))])]), _vm._v(" "), (_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/hcp"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("school")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Education")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": _vm.isHcpView && _vm.isHcpUser ? '/life/category/evidence-and-papers' : '/life'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("local_florist")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.isHcpView && _vm.isHcpUser ? 'Evidence and Papers' : _vm.$t('message.lifestyleMenuTitleText')))])]), _vm._v(" "), (_vm.isHcpUser && _vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/downloads"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Resources")])]) : _vm._e(), _vm._v(" "), (!_vm.questionsDisabled) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/questions"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v(_vm._s(_vm.isHcpView || _vm.isHcpUser ? 'textsms' : 'live_help'))]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.isHcpView && _vm.isHcpUser ? 'Forum' : _vm.$t('message.questionsMenuTitleText')))])]) : _c('div', {
    staticClass: "nav-item disabled"
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v(_vm._s(_vm.isHcpView || _vm.isHcpUser ? 'textsms' : 'live_help'))]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.isHcpView && _vm.isHcpUser ? 'Forum' : _vm.$t('message.questionsMenuTitleText')))])]), _vm._v(" "), (!_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/food-diary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("book")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.foodDiaryMenuTitleText')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nav-group"
  }, [_c('button', {
    staticClass: "nav-item nav-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.recipesOpen = !_vm.recipesOpen
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("restaurant")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.recipeMenuTitleText')))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons nav-caret"
  }, [_vm._v(_vm._s(_vm.recipesOpen ? 'expand_less' : 'expand_more'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipesOpen),
      expression: "recipesOpen"
    }],
    staticClass: "nav-nested"
  }, [_c('router-link', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "to": "/recipes/",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("view_carousel")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("All Recipes")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "to": "/recipes/favorites/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("grade")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Favourites")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "to": "/recipes/search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("search")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Search")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "to": "/recipes/generator/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Meal Plan Generator")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "to": "/recipes/mealplans/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("view_list")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("My Meal Plans")])])], 1)]), _vm._v(" "), (!_vm.isHcpView) ? _c('div', {
    staticClass: "nav-group"
  }, [_c('button', {
    staticClass: "nav-item nav-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.shopOpen = !_vm.shopOpen
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("shopping_cart")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.shopMenuTitleText')))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons nav-caret"
  }, [_vm._v(_vm._s(_vm.shopOpen ? 'expand_less' : 'expand_more'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopOpen),
      expression: "shopOpen"
    }],
    staticClass: "nav-nested"
  }, [_c('a', {
    staticClass: "nav-item nav-subitem",
    attrs: {
      "href": "https://shop.lowcarbprogram.com/collections/books",
      "target": "_blank"
    },
    on: {
      "click": _vm.closeIfMobile
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("book")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Books")])])])]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/add-progress"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.addProgressMenuTitleText')))])]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView && _vm.$store.state.user.scope.country.country_id === 41) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/coaching"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("school")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.coachingMenuTitleText')))])]) : _vm._e(), _vm._v(" "), (!_vm.isHcpUser || !_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/downloads"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.downloadsMenuTitleText')))])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/coaching"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("sports")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Coaching")])]), _vm._v(" "), (!_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": '/profile/' + _vm.$store.state.user.profile.profile_url
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("person")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.profileMenuTitleText')))])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/contact"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("feedback")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.feedbackMenuTitleText')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/settings"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("settings")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.settingsMenuTitleText')))])]), _vm._v(" "), (!_vm.isHcpView) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/faq"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("help")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.$t('message.faqMenuTitleText')))])]) : _vm._e(), _vm._v(" "), (_vm.isHcpView || _vm.isHcpUser) ? _c('button', {
    staticClass: "nav-item hcpSwitch",
    class: {
      disabled: !_vm.isHcpVerified && _vm.isHcpView
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleHcpSwitchModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons nav-icon"
  }, [_vm._v("swap_horizontal_circle")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.isHcpView ? _vm.$t('message.labelSwitchPatient') : _vm.$t('message.labelSwitchHcp')))])]) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.status.payment.paid === false) ? _c('payment-call-to-action') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "page-content",
    class: {
      sidebarOpen: _vm.isOpen,
      isMobile: !_vm.docked
    }
  }, [((_vm.$route.meta.isAuthView && !_vm.$route.meta.hideRegisterAppBar)) ? _c('mu-appbar', {
    class: {
      appBarClosed: !_vm.isOpen,
      noShadow: _vm.$route.meta.hideShadow
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.applicationContext === 'grohealth') ? _c('img', {
    staticClass: "logo",
    attrs: {
      "width": "26",
      "src": require("assets/gro-small.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.applicationContext === 'lowcarbprogram') ? _c('img', {
    staticClass: "logo",
    attrs: {
      "width": "200",
      "src": "static/logos/lcp-logo.svg"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showLogOut) ? _c('div', {
    staticClass: "logout-button",
    on: {
      "click": _vm.logOut
    }
  }, [_c('span', [_c('mu-icon', {
    attrs: {
      "value": "exit_to_app"
    }
  }), _vm._v("\n              Log out\n            ")], 1)]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.isAuthView && _vm.$store.state.user.scope) ? _c('mu-appbar', {
    class: {
      appBarClosed: !_vm.isOpen,
      transparent: _vm.$route.meta.isBlueBg
    },
    attrs: {
      "title": _vm.replaceTitle ? _vm.replaceTitle : _vm.$route.meta.title + (_vm.$route.meta.hasCustomTitle ? ': ' + _vm.externalTitle : '')
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "slot": "left",
      "iconClass": "menu-icon material-icons-round",
      "icon": "menu"
    },
    on: {
      "click": function($event) {
        return _vm.toggle(false)
      }
    },
    slot: "left"
  }), _vm._v(" "), (_vm.$route.meta.isChild) ? _c('mu-icon-button', {
    staticClass: "animated fadeInRight",
    attrs: {
      "slot": "left",
      "icon": "chevron_left"
    },
    on: {
      "click": function($event) {
        return _vm.goBack(_vm.$route)
      }
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), ((_vm.isHcpView || _vm.isHcpUser) && _vm.isHcpVerified) ? _c('mu-icon', {
    staticClass: "mobileHcpSwitch",
    attrs: {
      "slot": "right",
      "value": "swap_horizontal_circle",
      "color": "#FFF"
    },
    on: {
      "click": function($event) {
        _vm.toggleHcpSwitchModal = true
      }
    },
    slot: "right"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "20px",
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('span', {
    staticClass: "user-block pointer",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile()
      }
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.$store.state.user.scope.use_display_name ? _vm.$store.state.user.scope.display_name : _vm.$store.state.user.scope.firstname))]), _vm._v(" "), (_vm.$store.state.user.scope.profile_thumb !== null) ? _c('mu-avatar', {
    staticStyle: {
      "margin-left": "12px",
      "border": "2px solid #fff"
    },
    attrs: {
      "size": 32,
      "src": _vm.$store.state.user.scope.profile_thumb,
      "color": "white",
      "backgroundColor": "grey"
    },
    on: {
      "click": _vm.goToProfile
    }
  }) : _c('mu-avatar', {
    staticClass: "blue",
    staticStyle: {
      "margin-left": "12px",
      "border": "2px solid #fff"
    },
    attrs: {
      "size": 32,
      "color": "white",
      "backgroundColor": "grey"
    },
    on: {
      "click": _vm.goToProfile
    }
  }, [_vm._v("\n            " + _vm._s(_vm.upperTwoInitials) + "\n          ")])], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('notifications-panel', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "right",
      "visible": _vm.isNotificationsPanelVisible
    },
    on: {
      "panelHidden": _vm.hidePanelFn
    },
    slot: "right"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.isAuthView && !_vm.$store.state.user.scope) ? _c('mu-appbar', {
    class: {
      appBarClosed: !_vm.isOpen
    },
    attrs: {
      "title": _vm.$route.meta.title + (_vm.$route.meta.hasCustomTitle ? ': ' + _vm.externalTitle : '')
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-content-block', {
    staticClass: "main-content",
    attrs: {
      "id": _vm.$route.meta.id
    },
    nativeOn: {
      "scroll": function($event) {
        return _vm.handleScroll.apply(null, arguments)
      }
    }
  }, [(_vm.isHcpView && _vm.isHcpUser) ? _c('hcp-search') : _vm._e(), _vm._v(" "), (_vm.$store.state.list.diabetes_types) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "siteFooter content",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50",
      "align": "center"
    }
  }, [_c('div', [_vm._v("\n\n                " + _vm._s(_vm.$t('message.labelMadeWith')) + "\n\n                "), _c('mu-icon', {
    attrs: {
      "color": "#D83E38",
      "size": 12,
      "value": "favorite"
    }
  }), _vm._v(" "), (_vm.applicationContext === 'grohealth') ? _c('span', [_vm._v("grohealth.com")]) : _vm._e(), _vm._v(" "), (_vm.applicationContext === 'lowcarbprogram') ? _c('span', [_vm._v("lowcarbprogram.com")]) : _vm._e(), _vm._v(" © " + _vm._s(_vm.currentYear) + "\n              ")], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$route.meta.paymentWall && _vm.$store.state.status.payment.paid === false) ? _c('paywall', {
    attrs: {
      "show": _vm.showPaywall
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHcpUser) ? _c('hcp-switch-modal', {
    attrs: {
      "open": _vm.toggleHcpSwitchModal
    },
    on: {
      "close": function($event) {
        return _vm.closeHcpSwitchModal()
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 3834
// module chunks = 1